<template>
  <div class="c1-main">

    <!-- TOP BAR -->
    <div class="c1-tib" @click="g1SlideOpen = null">
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': g1PanelActiveContent === 'viki' }"
          @click.stop="g1SelectPanel('viki')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
      </div>
      <div class="c1-tib-center"></div>
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-psel-wrap">
          <div class="c1-psel-btn" :class="{ active: g1PanelIsOpen }" @click.stop="g1PanelBtnClick()">
            <span class="c1-psel-btn-ico">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </span>
            <span class="c1-psel-btn-lbl">Games</span>
            <svg class="c1-psel-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel backdrop -->
    <transition name="c1-bd-fade">
      <div v-if="g1SlideOpen" class="c1-panel-backdrop" @click.stop="g1SlideOpen = null"></div>
    </transition>

    <!-- UNIFIED RIGHT PANEL -->
    <div class="c1-panel" :class="{ 'c1-panel--open': g1PanelIsOpen }" @click.capture="g1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': g1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- USER STRIP -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- TIMEZONE BAR -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="g1SlideOpen = null; c1NavMode = 'panels'"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- Panels mode -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr"><span style="font-size:13px;line-height:1;flex-shrink:0">🎮</span>Games</div>
            <div class="c1-psel-sub" :class="{ on: g1PanelActiveContent === 'viki' }" @click.stop="g1SelectPanel('viki')">
              <span class="c1-psel-sub-dot" style="background:var(--c1-viki,#29b8d4)"></span>
              <span class="c1-psel-sub-lbl">Viki AI</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div>
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
            <span class="c1-panel-hdr-ttl c1-panel-hdr-ttl--back" @click.stop="g1GoBackToNav()">Viki AI</span>
            <div class="c1-panel-back-btn" @click.stop="g1GoBackToNav()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">
            <template v-if="g1PanelActiveContent === 'viki'">
              <div class="c1-co-lbl">Viki AI</div>
              <div class="c1-viki-chat-wrap">
                <div class="c1-viki-msg c1-viki-msg--viki">
                  <div class="c1-viki-bubble">Hi! I'm Viki. Ask me anything about Games.</div>
                </div>
              </div>
            </template>
          </div>
        </div>

      </div>
    </div>

    <!-- GAMES BODY -->
    <div class="root">
    <div class="tabk">
      <button
        v-for="tab in setTabs"
        :key="tab.id"
        :class="{ active: selectedGamesTab === tab.alias }"
        @click="selectedGamesTab = tab.alias"
      >
        {{ tab.name }}
      </button>
    </div>
    <div
      v-if="
        selectedGamesTab === 'Snakes' &&
          (permGames.includes(1) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <Snakes />
    </div>
    <div
      v-if="
        selectedGamesTab === 'TETRIS' &&
          (permGames.includes(1) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <Tetris />
    </div>
    <div
      v-if="
        selectedGamesTab === 'BREAKER' &&
          (permGames.includes(2) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <Brick />
    </div>
    <div
      v-if="
        selectedGamesTab === 'PACMAN' &&
          (permGames.includes(5) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <Pacman />
    </div>
    <div
      v-if="
        selectedGamesTab === 'SNAKE' &&
          (permGames.includes(3) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <snake />
    </div>
    <div
      v-if="
        selectedGamesTab === 'TIC' &&
          (permGames.includes(4) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <tic />
    </div>
    <div
      v-if="
        selectedGamesTab === 'PONG' &&
          (permGames.includes(6) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <pong />
    </div>

    <div
      v-if="
        selectedGamesTab === 'Memory' &&
          (permGames.includes(7) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <Memory />
    </div>
    <div
      v-if="
        selectedGamesTab === 'MINESWEEPER' &&
          (permGames.includes(8) || checkPermissions(this.auth, [1, 2, 3, 12]))
      "
    >
      <Minesweeper />
    </div>
    <div
        v-if="
        selectedGamesTab === 'SIMONGAME' &&
          (permGames.includes(9) || checkPermissions(this.auth, [1, 2, 3, 12]))
      ">
       <TheSimonGame/>
    </div>
  </div><!-- end .root -->
  </div><!-- end .c1-main -->
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Snake from "../snake.game/containers/Snake.container";
import Tetris from "../tetris.game/containers/Tetris.container";
import Brick from "../brick_breaker.game/containers/Brick.container";
import Pacman from "../pacman.game/containers/Pacman.container";
import Tic from "../tic.game/containers/Tic.container";
import Pong from "../pong.game/containers/Pong.container";
import Memory from "../memory_game/container/MemoryGame.container";
import Minesweeper from "../minesweeper.game/containers/Minesweeper.container";
import apiClientCreator from "../../../helpers/api/request";
import Snakes from "../snakes.game/containers/Snakes.container";
import TheSimonGame from "../The_Simon_Game.game/container/TheSimonGame.container";
import VikiFace from "../../clients1.feature/VikiFace.vue";

export default {
  name: "Games.container",
  computed: {
    ...mapState("user", ["auth"]),
    g1PanelIsOpen() { return this.g1SlideOpen === 'panel'; },
    g1PanelAtContent() { return !!this.g1PanelActiveContent; },
    c1CurrentPageLabel() {
      const map = {
        '/clients1': 'Clients', '/tasks1': 'Tasks', '/stats1': 'Statistics',
        '/chat1': 'Chat', '/communications1': 'Communications', '/affiliation1': 'Affiliation',
        '/finance1': 'Finance', '/shifts1': 'Shifts', '/games1': 'Games',
        '/users1': 'Users', '/brokers1': 'Brokers', '/security1': 'Security',
        '/quiz1': 'Quiz', '/instruction1': 'Instructions', '/settings1': 'Settings', '/profile1': 'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.auth && this.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.auth && this.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1RoleLabel() {
      const map = { 1: "Admin", 2: "Team Leader", 3: "Manager", 4: "Senior Agent", 5: "Agent", 6: "Junior Agent", 7: "New Agent", 8: "Support", 9: "Retention", 10: "Finance", 12: "Super Admin" };
      return map[(this.auth && this.auth.user && this.auth.user.role)] || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },
  },
  components: {
    Snakes,
    Pacman,
    Brick,
    Tetris,
    Snake,
    Tic,
    Pong,
    Memory,
    Minesweeper,
    TheSimonGame,
    VikiFace,
  },
  data() {
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      permGames: [], // hadrcoded!!!
      selectedGamesTab: "",
      g1SlideOpen: 'nav',
      g1PanelActiveContent: null,
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      setTabs: [
        {
          id: 0,
          name: "Tetris",
          alias: "TETRIS"
        },
        {
          id: 1,
          name: "Break Breaker",
          alias: "BREAKER"
        },
        {
          id: 2,
          name: "Pacman",
          alias: "PACMAN"
        },
        {
          id: 3,
          name: "Snake",
          alias: "SNAKE"
        },
        {
          id: 4,
          name: "Tic Tac Toe",
          alias: "TIC"
        },
        {
          id: 5,
          name: "Pong",
          alias: "PONG"
        },
        {
          id: 6,
          name: "Memory Game",
          alias: "Memory"
        },
        {
          id: 7,
          name: "Mine Sweeper",
          alias: "MINESWEEPER"
        },
        {
          id: 8,
          name: "Snakes And Ladders",
          alias: "Snakes"
        },
        {
          id: 9,
          name: "The Simon Game",
          alias: "SIMONGAME"
        },

      ]
    };
  },
  beforeCreate() {},
  beforeDestroy() {
    clearInterval(this._c1StatusInterval);
  },

  mounted() {
    this.c1StatusSince = Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
  },
  created() {
    if (sessionStorage.getItem('c1keepNav')) { sessionStorage.removeItem('c1keepNav'); this.c1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    sessionStorage.removeItem('c1openPanel');
    let userId = this.auth.user.id;
    apiClientCreator(`users/games/perm/check`)
      .get("")
      .then(res => {
        this.permGames = res.data;
        return res;
      });
  },
  methods: {
    c1SetStatus(s) {
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1StatusMenuOpen = false;
    },
    c1TickStatus() {
      const sec = Math.floor((Date.now() - this.c1StatusSince) / 1000);
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = sec % 60;
      this.c1StatusElapsed = h > 0
        ? `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
        : `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    g1FilterPanelClick(e) {
      // Panel stays open after selecting — user uses back (←) or X to close
    },
    g1PanelBtnClick() {
      this.g1SlideOpen = this.g1SlideOpen === 'panel' ? null : 'panel';
      if (this.g1SlideOpen === null) this.g1PanelActiveContent = null;
    },
    g1SelectPanel(name) {
      this.g1PanelActiveContent = name;
      this.g1SlideOpen = 'panel';
    },
    g1GoBackToNav() {
      this.g1PanelActiveContent = null;
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },
  }
};
</script>

<style scoped>
.root {
  height: 100%;
  font-family: Montserrat !important;
}

.tabk {
  float: left;
  background-color: #f1f1f1;
  height: 100%;
}

.tabk button {
  display: block;
  font-size: 8pt;
  background-color: inherit;
  color: black;
  padding: 22px 16px;
  width: 100%;
  height: 30px;
  border: none;
  outline: none;
  text-align: left;
  cursor: pointer;
  transition: 0.2s;
  line-height: 8pt;
}

.tabk button.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  width: 107%;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.tabk button:hover {
  background: #44a2d2;
  color: white;
  width: 107%;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.tabk span {
  font-size: 8pt;
  font-weight: normal;
}
</style>
